/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_USERS = 'REQUEST_USERS';
export const REQUEST_USERS_SUCCESS = 'REQUEST_USERS_SUCCESS';
export const REQUEST_USERS_FAILURE = 'REQUEST_USERS_FAILURE';

export const REQUEST_USER = 'REQUEST_USER';
export const REQUEST_USER_SUCCESS = 'REQUEST_USER_SUCCESS';
export const REQUEST_USER_FAILURE = 'REQUEST_USER_FAILURE';

export const REQUEST_ADD_USER = 'REQUEST_ADD_USER';
export const REQUEST_ADD_USER_SUCCESS = 'REQUEST_ADD_USER_SUCCESS';
export const REQUEST_ADD_USER_FAILURE = 'REQUEST_ADD_USER_FAILURE';

export const REQUEST_UPDATE_USER = 'REQUEST_UPDATE_USER';
export const REQUEST_UPDATE_USER_SUCCESS = 'REQUEST_UPDATE_USER_SUCCESS';
export const REQUEST_UPDATE_USER_FAILURE = 'REQUEST_UPDATE_USER_FAILURE';

export const REQUEST_DELETE_USER = 'REQUEST_DELETE_USER';
export const REQUEST_DELETE_USER_SUCCESS = 'REQUEST_DELETE_USER_SUCCESS';
export const REQUEST_DELETE_USER_FAILURE = 'REQUEST_DELETE_USER_FAILURE';

export const REQUEST_RESET_PASSWORD_USER = "REQUEST_RESET_PASSWORD_USER";
export const REQUEST_RESET_PASSWORD_USER_SUCCESS = 'REQUEST_RESET_PASSWORD_USER_SUCCESS';
export const REQUEST_RESET_PASSWORD_USER_FAILURE = 'REQUEST_RESET_PASSWORD_USER_FAILURE';

export const REQUEST_FORGOT_PASSWORD = 'REQUEST_FORGOT_PASSWORD';
export const REQUEST_FORGOT_PASSWORD_SUCCESS = 'REQUEST_FORGOT_PASSWORD_SUCCESS';
export const REQUEST_FORGOT_PASSWORD_FAILURE = 'REQUEST_FORGOT_PASSWORD_FAILURE';
